import moment from 'moment';

import BaseType from './BaseType';
import AvatarData from './AvatarData';

export default class Staff extends BaseType {
  id = 0;

  createdAt = moment();

  updatedAt = moment();

  firstName = '';

  lastName = '';

  // TODO. Need to add UpperHandImage type
  profileImage: { url: string } = { url: '' };

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export function getAvatarContent(staff: Staff[]): AvatarData {
  if (!staff.length) {
    return { avatarName: '🙎‍♀️', src: '', subText: 'Staff unassigned' };
  }

  if (staff.length > 1) {
    return {
      avatarName: staff.length.toString(),
      src: '',
      subText: `${staff.length} instructors`,
    };
  }
  const staffMember = staff[0];

  return {
    avatarName: staffMember?.fullName,
    src: staffMember?.profileImage?.url, // NOTE: eventually want to account for invalid URL
    subText: staffMember?.fullName,
  };
}
